import { ColumnsType } from "antd/es/table";
import { Tag } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { FortnoxCompanyStatus } from "shared/api";

export const useFortnoxCompanyColumns =
  (): ColumnsType<FortnoxCompanyStatus> => [
    {
      title: "Name",
      dataIndex: "chainlinx_name",
      key: "chainlinx_name",
    },
    {
      title: "Fortnox Customer Number",
      dataIndex: "fortnox_customer_number",
      key: "fortnox_customer_number",
    },
    {
      title: "Fortnox Name",
      dataIndex: "fortnox_name",
      key: "fortnox_name",
    },
    {
      title: "Not Found",
      dataIndex: "error_not_found",
      key: "error_not_found",
      render: (error_not_found: boolean) =>
        error_not_found ? (
          <Tag color="error" icon={<CloseCircleOutlined />}>
            Error
          </Tag>
        ) : (
          <Tag color="green" icon={<CheckCircleOutlined />}>
            Found
          </Tag>
        ),
    },
  ];
